export default function createBroadcastChannel() {
  return new BroadcastChannel('videoscribe');
}
